import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { BUILDING } from "@/lib/constants";

const BuildingContext = createContext(BUILDING);

export function BuildingProvider({ children }) {
  const [building, setBuilding] = useState(BUILDING);

  useEffect(() => {
    const url = new URL(window.location.href);
    const b = url.searchParams.get("b");
    if (b) {
      window.sessionStorage.setItem("mc_building", b);
      url.searchParams.delete("b");
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    }
    api.get("/building").then((r) => setBuilding(r.data)).catch(() => {});
  }, []);

  return <BuildingContext.Provider value={building}>{children}</BuildingContext.Provider>;
}

export function useBuilding() {
  return useContext(BuildingContext);
}
